import "referentiel-article-module-recherche/dist/rac.css";

import Autoplay from "embla-carousel-autoplay";
import {ReactElement, useEffect, useState} from "react";
import {ErrorBoundary} from "react-error-boundary";
import {RechercheProduit} from "referentiel-article-module-recherche";

import {getActualites} from "@/api/actualite";
import {getEvenement} from "@/api/evenement";
import {getMassification} from "@/api/massification";
import {getOperationCommercial} from "@/api/operationCommercial";
import {Actualite, ActualiteSkeleton} from "@/components/Actualite/Actualite";
import {ErrorComponent} from "@/components/Error/Error";
import EvenementModale from "@/components/Evenement/EvenementModale";
import {Modale} from "@/components/Modale/Modale";
import ModuleActualite from "@/components/Module/ModuleActualite";
import ModuleCalendarEvent from "@/components/Module/ModuleCalendarEvent";
import ModuleOperationCommercial from "@/components/Module/ModuleOperationCommercial";
import Section from "@/components/Section/Section";
import Title from "@/components/Section/Title";
import {Carousel, CarouselContent} from "@/components/ui/carousel";
import {CarouselItem} from "@/components/ui/carousel";
import {actualite} from "@/types/actualite";
import {evenement} from "@/types/evenement";
import {modale} from "@/types/modale";
import {operationCommercial} from "@/types/operationCommercial";

function Accueil(): ReactElement {
  const defaultModal: modale = {isOpen: false, title: "", children: <></>};
  const [modal, setModal] = useState<modale>(defaultModal);
  const closeModal = (): void => {
    setModal(defaultModal);
  };
  const [allOperationCommercial, setAllOperationCommercial] = useState<
    operationCommercial[] | undefined
  >(undefined);
  const [allEvent, setAllEvent] = useState<evenement[] | undefined>(undefined);
  const [allActu, setAllActu] = useState<actualite[] | undefined>(undefined);
  const [allMassification, setAllMassification] = useState<
    actualite[] | undefined
  >(undefined);

  useEffect(() => {
    const getAllOperationCommercial = async (): Promise<void> => {
      setTimeout(async () => {
        const opertations = await getOperationCommercial();
        setAllOperationCommercial(opertations);
      }, 100);
    };
    const getAllEvent = async (): Promise<void> => {
      setTimeout(async () => {
        const evenements = await getEvenement();
        setAllEvent(evenements);
      }, 100);
    };
    const getAllActu = async (): Promise<void> => {
      setTimeout(async () => {
        const actualites = await getActualites();
        setAllActu(actualites);
      }, 100);
    };
    const getAllMassificaiton = async (): Promise<void> => {
      setTimeout(async () => {
        const massification = await getMassification();
        setAllMassification(massification);
      }, 100);
    };

    getAllOperationCommercial();
    getAllEvent();
    getAllActu();
    getAllMassificaiton();
  }, []);

  const AllMassification: ReactElement[] | undefined = allMassification?.map(
    (article: actualite, index) => {
      return (
        <CarouselItem
          className="basis-auto w-fill pr-2 pl-2"
          key={`${index}_${article.id}`}>
          <Actualite article={article} isLargeFormat={true} />
        </CarouselItem>
      );
    },
  );

  const calendarClick = (evenements: evenement[]): void => {
    if (evenements.length) {
      const selectedDate = new Date(evenements[0]?.date);
      const modalContent: ReactElement<evenement, typeof EvenementModale>[] =
        evenements?.map((event, index) => {
          return (
            <EvenementModale event={event} key={`${index}-${event.libelle}`} />
          );
        });

      setModal({
        isOpen: true,
        children: modalContent,
        title: `Evenement du ${selectedDate.getDate()}/${(selectedDate.getMonth() + 1).toString().padStart(2, "0")}/${selectedDate.getFullYear()}`,
      });
    }
  };
  const sliderMassification: ReactElement = (
    <Section id="massification">
      {AllMassification ? (
        <Carousel
          opts={{
            align: "start",
            loop: true,
          }}
          plugins={[
            Autoplay({
              delay: 5000,
              stopOnInteraction: false,
              stopOnMouseEnter: true,
            }),
          ]}
          className="grab">
          <CarouselContent className="carouselContent">
            {AllMassification}
          </CarouselContent>
        </Carousel>
      ) : (
        <div style={{width: "100%", overflow: "hidden", display: "flex"}}>
          <ActualiteSkeleton isLargeFormat={true} />
        </div>
      )}
    </Section>
  );

  return (
    <>
      <div id="responsive-slider">{sliderMassification}</div>
      <div id="home">
        <div id="left-content">
          {sliderMassification}
          <Title
            title="Actualités"
            link="/actualites"
            linkTitle="Voir toutes les actualités"
            linkLabel="Tout Voir"
          />
          <ErrorBoundary
            fallback={
              <ErrorComponent
                text="Une erreur est survenu sur les actualité, veuillez réessayer"
                buttonToRefresh={true}
              />
            }>
            <ModuleActualite actualites={allActu} />
          </ErrorBoundary>
        </div>
        <div id="right-content">
          <Section id="RAC">
            <Title
              title="Référentiel Articles"
              link="/referentiel-articles"
              linkTitle="Accéder au RAC"
              linkLabel="Accéder au RAC"
            />
            <ErrorBoundary
              fallback={
                <ErrorComponent
                  text="Une erreur est survenu sur le RAC, veuillez réessayer"
                  buttonToRefresh={true}
                />
              }>
              <div className="module-RAC">
                <RechercheProduit
                  notIsCollaborateur={true}
                  fixedHeaderOnScroll={false}
                  scrollArticle={false}
                  scrollTopOnSearch={false}
                />
              </div>
            </ErrorBoundary>
          </Section>
          <ErrorBoundary
            fallback={
              <ErrorComponent
                text="Une erreur est survenu sur les Opération Commerciale, veuillez réessayer"
                buttonToRefresh={true}
              />
            }>
            <ModuleOperationCommercial operations={allOperationCommercial} />
          </ErrorBoundary>
          <Section id="calendrier">
            <Title
              title="Evenement"
              link="#"
              linkTitle="Voir toutes les évenements"
              linkLabel="Tout Voir"
            />
            <ErrorBoundary
              fallback={
                <ErrorComponent
                  text="Une erreur est survenu sur le calendrier, veuillez réessayer"
                  buttonToRefresh={true}
                />
              }>
              <ModuleCalendarEvent
                evenements={allEvent}
                onClick={event => calendarClick(event)}
              />
            </ErrorBoundary>
          </Section>
        </div>

        <Modale
          isOpen={modal.isOpen}
          close={closeModal}
          title={modal.title}
          children={modal.children}
        />
      </div>
    </>
  );
}

export default Accueil;
